export const favorites = {
    state: {
        status: 'idle',
        favorites: [],
        initLoad: false
    },
    mutations: {
        SET_FAVORITES(state, payload) {
            state.favorites = payload
        },
        SET_FAVORITES_STATUS(state, payload) {
            state.status = payload
        },
        SET_FAVORITES_INIT_LOAD(state, payload) {
            state.initLoad = payload
        }
    },
    actions: {
        async loadFavoritePromos({ state, commit }) {
            if (state.favorites.length > 0) {
                return
            }

            try {
                const { status, data } = await this.$api.get('cciFavourites', {
                    params: {
                        per: 99999
                    }
                })

                if (status !== 200 || !data?.data) {
                    throw new Error(data?.message || 'Failed GET favorites')
                }

                commit('SET_FAVORITES', data.data)
            } catch (err) {
                console.log(err)
            }
        },
        toggleFavorites({ state, dispatch, commit }, payload) {
            let favorites = state.favorites

            const action = !payload.favorite ? 'post' : 'delete'
            const id = !payload.favorite
                ? payload.promoId
                : state.favorites.find(el => el.promo_id === payload.promoId).id

            return this.$api[action]('cciFavourites/' + id).then(response => {
                if (response.status === 200) {
                    if (response.data.data && !payload.favorite) {
                        favorites.push(response.data.data)
                    }
                    if (payload.favorite) {
                        favorites = favorites.filter(
                            el => el.promo_id !== payload.promoId
                        )
                        commit('SET_FAVORITES', favorites)
                    }
                    const text = payload.favorite
                        ? 'Usunięto z listy'
                        : 'Zapisano na później'
                    dispatch('addNotification', {
                        type: 'success',
                        content: text
                    })
                } else {
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                }
                return response
            })
        }
    },
    getters: {
        getAllFavorites: state => {
            if (state.favorites) {
                return state.favorites.map(el => el.promo_id)
            }
        },
        getFavoriteById: state => id => {
            return (
                state.favorites.map(el => el.promo_id).filter(el => el === id)
                    .length > 0
            )
        },
        getFavoritesInitLoad: state => state.initLoad
    }
}
